/*
  src/redux/entities/accounting.js

  Created by erikchristensen on 10/19/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

function createConstant(action){
  return ['portal', 'accounting', action].join('/');
}

export const ADD_FUNDS_REQUESTED = createConstant('ADD_FUNDS_REQUESTED');
export const FUNDS_ADDED = createConstant('FUNDS_ADDED');
export const FUNDS_FAILED_TO_ADD = createConstant('FUNDS_FAILED_TO_ADD');

export const FUNDS_TRANSFER_REQUESTED = createConstant('FUNDS_TRANSFER_REQUESTED');
export const FUNDS_TRANSFERRED = createConstant('FUNDS_TRANSFERRED');
export const FUNDS_FAILED_TO_TRANSFER = createConstant('FUNDS_FAILED_TO_TRANSFER');

export const TRANSFER_HISTORY_REQUESTED = createConstant('TRANSFER_HISTORY_REQUESTED');
export const TRANSFER_HISTORY_LOADED = createConstant('TRANSFER_HISTORY_LOADED');
export const TRANSFER_HISTORY_FAILED_TO_LOAD = createConstant('TRANSFER_HISTORY_FAILED_TO_LOAD');

export const LIST_OF_ACCOUNTS_REQUESTED = createConstant('LIST_OF_ACCOUNTS_REQUESTED');
export const LIST_OF_ACCOUNTS_LOADED = createConstant('LIST_OF_ACCOUNTS_LOADED');
export const LIST_OF_ACCOUNTS_FAILED_TO_LOAD = createConstant('LIST_OF_ACCOUNTS_FAILED_TO_LOAD');


// WEBPACK FOOTER //
// ./src/shared/redux/accounting/constants.js